$(document).ready(function () {
  var $gaugeContainer = $('.js-gauge-v2');
  if($gaugeContainer.length){
    new Gauge($gaugeContainer[0], {
      max: $gaugeContainer.data('max'),
      showValue: false,
      dialStartAngle: 120,
      dialEndAngle: 60,
      gaugeClass: "gauge-block__gauge",
      dialClass: "gauge-block__dial",
      valueDialClass: "gauge-block__value-dial"
    }).setValueAnimated($gaugeContainer.data('value'), 1);
  }
});
